import React from "react";
import IconPlay from "./Icons/IconPlay";
import IconPause from "./Icons/IconPause";
import IconRestart from "./Icons/IconRestart";

export default props => (
  <div id="TLcontrols" className="animation-controls">
    <div className="buttons">
      <button
        className={`play btn draw-border ${props.color ? props.color : null}`}
        aria-label="play animation"
      >
        <IconPlay color={props.color} />
      </button>
      <button
        className={`pause btn draw-border ${props.color ? props.color : null}`}
        aria-label="pause animation"

      >
        <IconPause color={props.color} />
      </button>
      <button
        className={`restart btn draw-border ${
          props.color ? props.color : null
        }`}
        aria-label="restart animation"
      >
        <IconRestart color={props.color} />
      </button>
    </div>
    <input
      className={props.color ? `${props.color} progress` : "progress"}
      aria-label="seek animation"
      step="1"
      type="range"
      min="0"
      max="100"
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/AnimationControls.js